import { useMemo } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles, categories } from '@/mocks/data';

const articleContentMap: Record<number, string[]> = {
  1: [
    '据知情人士透露，该男星近期正在与某当红小花传绯闻，此次深夜密会让人大跌眼镜。现场目击者称两人在会所停留近三个小时，期间举止亲密，完全不避嫌。',
    '该会所是京城知名的高端私人场所，入会门槛极高，普通狗仔根本无法靠近。此次能够拍到如此清晰的画面，据说是内部人员匿名提供。',
    '据圈内人士分析，如果此事属实，可能会对该男星目前的代言合约产生影响。多个品牌方已经紧急联系其工作室求证，但目前尚未得到正式回应。',
    '更令人关注的是，该男星此前在多个公开场合营造的是"单身专注事业"的人设。如果恋情曝光，人设崩塌将不可避免。粉丝群体已经出现分裂，一部分选择相信偶像，另一部分则表示"塌房了"。',
    '截至发稿前，该男星工作室仍未就此事发表任何声明。我们将持续关注事态发展，第一时间为大家带来最新消息。',
  ],
  2: [
    '一份疑似节目内部聊天记录在网络疯传，多位导师对选手真实评价令人震惊。截图中某位导师直言："某选手的实力完全达不到晋级标准，全靠经纪公司在背后运作。"',
    '该聊天记录据称来自节目组工作人员的手机，在深夜被匿名发布到某论坛后迅速扩散。虽然帖子很快被删除，但截图已经在各大社交平台广泛传播。',
    '业内人士分析称，选秀节目的选手排名长期以来都存在争议。此次聊天记录的曝光，或将揭开选秀行业潜规则的一角。',
    '节目组方面至今未对此事做出正式回应。据内部人士透露，节目组高层正在进行紧急公关会议，考虑是否要发布官方声明。',
    '值得注意的是，该节目已经是第三季播出，此前两季也曾有过类似的选手背景争议。如果此次事件处理不当，可能会对节目的公信力造成严重影响。',
  ],
  3: [
    '拥有千万粉丝的某知名网红被前合作伙伴爆料，其精心打造的励志人设背后另有真相。据爆料者称，该网红所谓的"白手起家"完全是无稽之谈。',
    '"他根本不是普通家庭出身，他父亲在某房地产公司担任高管，所谓的创业启动资金全是家里给的。"该前合作伙伴在直播中透露。',
    '更令人震惊的是，该网红多个爆款视频的创意和脚本均非本人原创，而是由背后的团队全权策划。其"才华横溢"的人设被彻底揭穿。',
    '事件发酵后，该网红的粉丝群出现了大面积脱粉现象。多个合作品牌已经紧急下架与其相关的宣传内容，商业合作面临全面崩塌的风险。',
    '我们在调查中发现，类似的网红虚假人设问题在行业中并不罕见。从"草根逆袭"到"学霸网红"，精心包装的人设背后往往隐藏着不为人知的真相。',
  ],
  4: [
    '某综艺节目录制现场突发意外，嘉宾当场翻脸离场。据悉是因为节目组临时更改游戏规则导致嘉宾不满，现场气氛一度十分尴尬。',
    '目击者称，该嘉宾在听到新规则后表情明显不悦，与导演组进行了长达十分钟的交涉。最终交涉无果后，直接摘掉麦克风离开了录制现场。',
    '其他几位嘉宾面面相觑，录制被迫中断近两个小时。节目组紧急召开会议商讨对策，最终决定在没有该嘉宾的情况下继续完成剩余内容的录制。',
    '此事在业内引发广泛讨论。多位综艺节目制作人表示，临时更改规则虽然常见，但应该在录制前与嘉宾充分沟通。',
    '该嘉宾事后在社交媒体发布了一条意味深长的动态："尊重是相互的。"引发网友热议。',
  ],
  5: [
    '一份被泄露的内部文件揭示了某知名影视公司对旗下艺人的苛刻合约条款。合同中多项限制性条款被业内人士称为"艺术卖身契"。',
    '据文件显示，该公司旗下艺人的合约期限普遍在10年以上，违约金高达数千万元。在此期间，艺人不得私自接任何商业活动，所有收入需与公司按比例分成。',
    '更令人关注的是，合同中还有一项"竞业限制"条款，即使合约到期后，艺人在两年内也不得签约其他同类型公司。',
    '多位法律界人士在接受采访时表示，这种合同条款在法律上存在争议。如果艺人通过法律途径维权，部分条款可能会被认定为无效。',
    '事件的曝光引发了行业内的广泛讨论。有评论认为，这种不合理的合约制度严重限制了艺人的职业发展，亟待行业规范和监管介入。',
  ],
  6: [
    '据剧组内部人员透露，原本已经确定的主演在开拍前被临时替换，背后原因令人唏嘘。一位实力派演员在已经进组进行了两个月的准备工作后突然被通知换人。',
    '"投资方指定要某流量明星出演，导演虽然不太满意，但也没有办法。"该内部人员透露，替换的决定完全来自投资方的压力。',
    '被替换的演员在社交媒体上发布了一条动态："有些事不是努力就能改变的"，似乎在暗指此事，但随后又删除了这条内容。',
    '业内人士指出，近年来影视行业"流量优先"的现象愈演愈烈，真正的演技派演员反而越来越难获得好的角色。长此以往，对国产影视作品的质量将造成严重影响。',
    '该电影预计将于明年暑期档上映。被替换后的新演员已经开始进组拍摄，但关于剧本质量是否需要为流量明星做调整，目前仍是未知数。',
  ],
  7: [
    '一组在某菜市场偶遇的照片在网络上疯传。照片中的女星素面朝天，穿着朴素，与平日荧幕上的精致形象形成巨大反差。',
    '拍摄者在社交平台发文称："在菜市场遇到XX，差点没认出来，素颜和电视上完全不一样。"配图九张，全方位多角度拍摄。',
    '该女星此前一直以"颜值天花板"的人设在网络上活跃，精修写真和活动照片均经过严格的修图处理。此次素颜照的曝光让许多网友大呼"幻灭"。',
    '支持者认为，明星也是普通人，素颜逛菜市场是再正常不过的事情。批评者则表示，既然选择了靠颜值吃饭，就应该接受公众的审视。',
    '该女星工作室至今未就此事做出回应。',
  ],
  8: [
    '知情人士向本网独家爆料，某平台拥有千万粉丝的情侣博主，实际上在半年前就已经分手，但为了维持商业价值，两人决定继续假扮恩爱。',
    '"他们现在完全是在按剧本表演。每次合体拍视频都像在完成任务，拍完各回各家。"该知情人士如是说。',
    '据悉，两人共同签约的品牌代言合约还有一年才到期。如果提前公开分手消息，将需要支付巨额的违约金。每条情侣视频的广告收入高达六位数。',
    '粉丝群体对此事反应激烈。有细心的粉丝表示早就发现两人的互动变少了，"以前每条视频都会互相评论，最近三个月完全没有互动。"',
    '此次事件的曝光再次引发了对"网红情侣"经济模式的讨论。当感情成为商品，真实与虚假的边界变得越来越模糊。',
  ],
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const article = useMemo(() => {
    if (!id) return null;
    return articles.find(a => a.id === parseInt(id, 10));
  }, [id]);

  const categoryInfo = useMemo(() => {
    if (!article) return null;
    return categories.find(c => c.id === article.category);
  }, [article]);

  const relatedArticles = useMemo(() => {
    if (!article) return [];
    return articles.filter(a => a.category === article.category && a.id !== article.id).slice(0, 3);
  }, [article]);

  const contentParagraphs = useMemo(() => {
    if (!article) return [];
    return articleContentMap[article.id] || [article.summary];
  }, [article]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-20">
          <div className="text-center py-20 px-4">
            <i className="ri-article-line text-5xl text-foreground-300"></i>
            <p className="mt-4 text-foreground-500">文章不存在或已被删除</p>
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 mt-4 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    ...(categoryInfo ? [{ label: categoryInfo.name, href: `/category/${categoryInfo.slug}` }] : []),
    { label: article.title },
  ];

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <article className="px-4 md:px-6 py-8 md:py-12 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <div className="mb-8">
              <div className="flex flex-wrap items-center gap-2 mb-4">
                <span className="px-2.5 py-1 bg-primary-50 text-primary-600 text-xs font-medium rounded-full">
                  {article.categoryName}
                </span>
                {article.tags.map(tag => (
                  <span key={tag} className="px-2.5 py-1 bg-background-100 text-foreground-500 text-xs rounded-full">
                    #{tag}
                  </span>
                ))}
              </div>

              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
                {article.title}
              </h1>

              <div className="flex flex-wrap items-center gap-4 mt-4 text-xs md:text-sm text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {article.publishDate}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views} 阅读
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-primary-500"></i>
                  {article.hot}° 热度
                </span>
              </div>
            </div>

            <div className="rounded-2xl overflow-hidden mb-10">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full aspect-[16/9] object-cover"
              />
            </div>

            <div className="prose-custom">
              {contentParagraphs.map((para, idx) => (
                <p key={idx} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
                  {para}
                </p>
              ))}
            </div>

            <div className="flex items-center gap-3 mt-10 pt-8 border-t border-background-200">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-background-100 text-foreground-700 text-sm font-medium rounded-full hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>返回
              </button>
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-home-line"></i>返回首页
              </Link>
            </div>

            {relatedArticles.length > 0 && (
              <section className="mt-14 pt-10 border-t border-background-200">
                <h3 className="text-xl md:text-2xl font-heading font-black text-foreground-950 mb-6">
                  相关推荐
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  {relatedArticles.map(ra => (
                    <Link
                      key={ra.id}
                      to={`/article/${ra.id}`}
                      className="group block rounded-xl bg-background-100 overflow-hidden hover:bg-background-200/70 transition-colors duration-300 cursor-pointer"
                    >
                      <div className="aspect-[16/10] overflow-hidden">
                        <img
                          src={ra.coverImage}
                          alt={ra.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-4">
                        <h4 className="text-sm font-bold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                          {ra.title}
                        </h4>
                        <div className="flex items-center gap-2 mt-2 text-xs text-foreground-400">
                          <span>{ra.publishDate}</span>
                          <span>·</span>
                          <span className="flex items-center gap-0.5">
                            <i className="ri-fire-line text-primary-500 text-xs"></i>
                            {ra.hot}°
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>
            )}
          </div>
        </article>
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": article.title,
          "description": article.summary,
          "datePublished": article.publishDate,
          "dateModified": article.publishDate,
          "url": `https://www.51heiliaobaike.com/article/${article.id}`,
          "image": article.coverImage,
          "author": {
            "@type": "Organization",
            "name": "51黑料网"
          },
          "publisher": {
            "@type": "Organization",
            "name": "51黑料网",
            "url": "https://www.51heiliaobaike.com/"
          },
          "articleSection": article.categoryName,
          "keywords": article.tags.join(', ')
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "首页",
              "item": "https://www.51heiliaobaike.com/"
            },
            ...(categoryInfo ? [{
              "@type": "ListItem",
              "position": 2,
              "name": categoryInfo.name,
              "item": `https://www.51heiliaobaike.com/category/${categoryInfo.slug}`
            }] : []),
            {
              "@type": "ListItem",
              "position": categoryInfo ? 3 : 2,
              "name": article.title,
              "item": `https://www.51heiliaobaike.com/article/${article.id}`
            }
          ]
        })
      }} />
    </>
  );
}